const styles = (theme) => ({
  headerStyle: {
    paddingRight: '10px',
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center'
  },
  headerIconStyles: {
    padding: '8px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor
  },
  iconLayout: {
    float: 'right',
    color: theme.iconColor,
    cursor: 'pointer',
    zIndex: 1,
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor      
    }
  },
  tabsIndicator: {
    backgroundColor: theme.HeaderSelectedText
  },
  tabRoot: {
    fontWeight: '600',
    fontSize: theme.textFontSize,
    lineHeight: '24px',
    color: theme.iconColor,
    minWidth: 60,
    '&:hover': {
      color: theme.HeaderSelectedText
    },
    '&$tabSelected': {
      color: theme.HeaderSelectedText
    },
    '&:focus': {
      color: theme.HeaderSelectedText
    }
  },
  tabSelected: {
    color: theme.HeaderSelectedText
  },

  iconContainer: {
    zIndex: 100
  },
  gridActionIcons: {
    '& $actionIcon': {
      paddingLeft: 10,
      '&:not(:last-child)': {
        borderRight: `1px solid ${theme.AppBGColor}`,
        paddingRight: 10
      }
    }
  },
  disableIcon: {
    cursor: 'not-allowed',
    opacity: 0.7
  },
  enableIcon: {
    cursor: 'pointer'
  },
  paperAnchor: {
    position: 'absolute',
    width: 300,
    zIndex: 110,
    backgroundColor: theme.ModalBGColor
  },
  holdProCustomerGrid: {
    height: 'calc(100% - 12px)',
    width: '100%',
  },
  holdProCustomerGridHeader: {
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize,
    fontWeight: 900,
    padding: 14
  },
  dataGrid: {
    minHeight: 150,
    '& .ag-theme-material .ag-body-horizontal-scroll': {
      borderWidth: '0px'
    },
    '& .statusBar': {
      display: 'none'
    },
    '& .ag-center-cols-viewport': {
      width: `calc(100% + 18px)`
    }
  },
  moduleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: 'bold',
    padding: `10px 32px`,
    fontSize: 14
  },
  moduleContainer: {
    margin: 32,
    border: `1px solid ${theme.AppBGColor}`,  
    height: '80%',  
  },
  moduleMessage: {
    fontSize: theme.textFontSize,
    paddingBottom: 32,
    color: theme.TextColor,
    maxWidth: '80%'
  },
  addHoldListPaperAnchor: {
    width: 446,
    zIndex: 1000,
    position: 'absolute',
    background: theme.ModalBGColor,
    top: 0,
    bottom: 0,
    height: 'fill-available',
    '@supports (-moz-available)': { height: '-moz-available' },
    '@supports (-webkit-fill-available)': { height: '-webkit-fill-available' }
  },
  errorMessage: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,   
    width: '100%',
    height: '70%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
  }
});
export default styles;
